import axios, { AxiosError } from "axios"

import { authStore } from "@src/app/authStore"
import { notify } from "@src/app/components/notify"
import { paths } from "@src/app/paths"
import { router } from "@src/pages"
import { API_PATH } from "@src/shared/config"
import {
  AuthApi,
  BankAccountsApi,
  BankPayoutsApi,
  CardMassPayoutsApi,
  ChargesApi,
  CheckoutsApi,
  ConfigApi,
  ConvertsApi,
  CountriesApi,
  CurrenciesApi,
  DepositsApi,
  FiatWithdrawalsApi,
  InvoicesApi,
  MassPayoutsApi,
  MerchantApi,
  OnRampApi,
  PaymentsApi,
  PayoutsApi,
  ProjectsApi,
  ReferrerApi,
  RefundsApi,
  SecurityApi,
  SettingsApi,
  SubmerchantsApi,
  TokensApi,
  TopupsApi,
  WhitelistAddressesApi,
  WhitelistDomainsApi,
  WhitelistIPsApi,
  WidgetAPIApi,
  WidgetsApi,
  WithdrawalsApi,
} from "./generated"

axios.defaults.withCredentials = true

export const client = axios.create({
  baseURL: API_PATH,
  withCredentials: true,
})

const authApi = new AuthApi(undefined, API_PATH, client)

const fiatWithdrawalsApi = new FiatWithdrawalsApi(undefined, API_PATH, client)

const bankAccountsApi = new BankAccountsApi(undefined, API_PATH, client)

const chargesApi = new ChargesApi(undefined, API_PATH, client)

const checkoutsApi = new CheckoutsApi(undefined, API_PATH, client)

const configApi = new ConfigApi(undefined, API_PATH, client)

const invoicesApi = new InvoicesApi(undefined, API_PATH, client)

const merchantApi = new MerchantApi(undefined, API_PATH, client)

const projectsApi = new ProjectsApi(undefined, API_PATH, client)

const tokensApi = new TokensApi(undefined, API_PATH, client)

const topupsApi = new TopupsApi(undefined, API_PATH, client)

const securityApi = new SecurityApi(undefined, API_PATH, client)

const currenciesApi = new CurrenciesApi(undefined, API_PATH, client)

const settingsApi = new SettingsApi(undefined, API_PATH, client)

const refundsApi = new RefundsApi(undefined, API_PATH, client)

const chargeApi = new ChargesApi(undefined, API_PATH, client)

const convertsApi = new ConvertsApi(undefined, API_PATH, client)

const depositsApi = new DepositsApi(undefined, API_PATH, client)
const payoutsApi = new PayoutsApi(undefined, API_PATH, client)

const countriesApi = new CountriesApi(undefined, API_PATH, client)

const widgetApi = new WidgetsApi(undefined, API_PATH, client)

const widgetAppApi = new WidgetAPIApi(undefined, API_PATH, client)

const whitelistAddressesApi = new WhitelistAddressesApi(
  undefined,
  API_PATH,
  client,
)

const cardMassPayoutsApi = new CardMassPayoutsApi(undefined, API_PATH, client)

const whitelistDomainsApi = new WhitelistDomainsApi(undefined, API_PATH, client)

const massPayoutsApi = new MassPayoutsApi(undefined, API_PATH, client)

const withdrawalsApi = new WithdrawalsApi(undefined, API_PATH, client)

const referrerApi = new ReferrerApi(undefined, API_PATH, client)
const paymentsApi = new PaymentsApi(undefined, API_PATH, client)

const subMerchantApi = new SubmerchantsApi(undefined, API_PATH, client)
const whiteListIpsApi = new WhitelistIPsApi(undefined, API_PATH, client)
const bankPayoutsApi = new BankPayoutsApi(undefined, API_PATH, client)

const onRampApi = new OnRampApi(undefined, API_PATH, client)

export type APIError = {
  errors?: any
  message: string
  target: string
}

export type APIPagination = {
  total: number
}

export type APIDataWithPagination<T = any, Property extends string = "data"> = {
  pagination: APIPagination
} & { [P in Property]: T }

export type APIResponse<T = any> = {
  data?: T
  error?: APIError
  message?: string
  success: boolean
}

// TODO: delete after UseFormErrors implementation
export const catchErrors = <T, R = T | undefined>(
  error: AxiosError<APIResponse<R>>,
) => {
  if (axios.isCancel(error)) {
    return undefined
  }

  const e = error as AxiosError<APIResponse<R>>

  if (e.isAxiosError && e.response) {
    if (e.response.status == 401) {
      if (authStore.merchant) {
        router.navigate(paths.auth).finally(() => {
          authStore.reset()
        })
      }
    } else {
      if (e?.response?.data?.error) {
        if (e?.response?.data?.error?.errors?.length > 0) {
          // @ts-ignore
          e?.response?.data?.error?.errors.forEach((error) => {
            notify.error(error?.message, e.response?.headers["x-trace-id"])
          })
        } else {
          notify.error(
            e?.response?.data?.error?.message,
            e.response.headers["x-trace-id"],
          )
        }
      } else {
        notify.error("Internal Server Error", e.response.headers["x-trace-id"])
      }
    }
  } else if (e.request) {
    notify.error("Network Error")
  } else {
    notify.error("System Error")
  }

  return undefined
}

export {
  authApi,
  bankAccountsApi,
  bankPayoutsApi,
  cardMassPayoutsApi,
  chargeApi,
  chargesApi,
  checkoutsApi,
  configApi,
  convertsApi,
  countriesApi,
  currenciesApi,
  depositsApi,
  fiatWithdrawalsApi,
  invoicesApi,
  massPayoutsApi,
  merchantApi,
  onRampApi,
  paymentsApi,
  payoutsApi,
  projectsApi,
  referrerApi,
  refundsApi,
  securityApi,
  settingsApi,
  subMerchantApi,
  tokensApi,
  topupsApi,
  whiteListIpsApi,
  whitelistAddressesApi,
  whitelistDomainsApi,
  widgetApi,
  widgetAppApi,
  withdrawalsApi,
}
